import classNames from 'classnames';
import { FC } from 'react';

import styles from './pickUpCart.module.scss';

interface PickUpCartProps {
  selected: boolean;
  className?: string;
}

const PickUpCart: FC<PickUpCartProps> = (props) => {
  const { selected, className } = props;
  return (
    <div
      className={classNames(
        styles.container,
        selected && styles.container_active,
        className,
      )}
    >
      <div>
        <div className={styles.container__row}>
          <p className={styles.container__text}>
            <b>Доставка</b>
          </p>
          <p className={styles.container__text}>
            <b>от 0 ₽</b>
          </p>
        </div>
      </div>
      <div>
        <div className={styles.container__row}>
          <p className={styles.container__text}>
            В пределах МКАД при заказе меньше 5000 ₽
          </p>
          <p className={styles.container__text}>350 ₽</p>
        </div>
        <div className={styles.container__row}>
          <p className={styles.container__text}>В города России (СДЭК)</p>
          <p className={styles.container__text}>от 300 ₽</p>
        </div>
      </div>
    </div>
  );
};

export default PickUpCart;
